import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './globals.css';
import { lockOrientation } from './lib/orientation-lock';
import './lib/sentry';

// Lock orientation as early as possible
lockOrientation();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
